"use strict";

var _toConsumableArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
exports.Hook = function (props) {
  return null;
};
exports.HookTester = function (props) {
  var data = props.hook.apply(props, _toConsumableArray(props.args));
  return react_1.default.createElement(exports.Hook, {
    data: data
  });
};